import { Modal, Button, Text } from '@pairy/pds-react';
import { useRouter } from 'next/router';

import { SetState } from '@/types/helper';

interface Props {
  isModalOpen: boolean;
  setModalOpen: SetState<boolean>;
}

const NotFoundErrorModal = ({ isModalOpen, setModalOpen }: Props) => {
  const router = useRouter();

  const moveToMain = () => router.replace('/user/pdf');

  return (
    <Modal.Root
      open={isModalOpen}
      onOpenChange={(open) => {
        if (!open) {
          moveToMain();
        }
        setModalOpen(open);
      }}
    >
      <Modal.Content>
        <Modal.Header title="접근할 수 없는 페이지입니다." />
        <Modal.Body>
          <Text>존재하지 않는 페이지 입니다</Text>
        </Modal.Body>
        <Modal.Footer>
          <Modal.Close>
            <Button
              variant="vermillion_400_fill"
              textVariant="lg-regular"
              paddingX={24}
              type="button"
              onClick={() => {
                moveToMain();
              }}
            >
              확인
            </Button>
          </Modal.Close>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
};

export default NotFoundErrorModal;
